import connectivityMonitorMessages from
  'ringcentral-integration/modules/ConnectivityMonitor/connectivityMonitorMessages';

export default {
  [connectivityMonitorMessages.disconnected]: 'Connessione di rete persa.',
};
